export const AUTH_RED = {
  title: "text-red-600",
  button: "bg-red-600 text-white hover:bg-red-700",
  link: "text-red-600 hover:text-red-700",
  stepActive: "bg-red-600 text-white",
  stepText: "text-red-600",
} as const;
